// extracted by mini-css-extract-plugin
export default {"title":"ForgotPassword_title__uor3s","link":"ForgotPassword_link__pGjwX"};